import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function ConfirmCreditsModal({
  show,
  onHide,
  title,
  message,
  cost = 0,
  balance = 0,
  confirmText = 'Confirm',
  onConfirm,
  buyUrl = '/buy_bulk_editions',
}) {
  const insufficient = balance < cost;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-2">{message}</div>
        <div className="small text-muted">
          Cost: <strong>{cost}</strong> • Your balance: <strong>{balance}</strong>
        </div>

        {insufficient && (
          <div className="alert alert-warning mt-3 mb-0">
            You don’t have enough credits — you have <strong>{balance}</strong>, but need <strong>{cost}</strong>.
            Get more to run this analysis.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        {insufficient ? (
          // No credits of this type → route to the buy page instead of a
          // Confirm that would just fail server-side.
          <Button variant="primary" href={buyUrl} as="a">
            Get credits
          </Button>
        ) : (
          <Button variant="primary" onClick={() => onConfirm?.()}>
            {confirmText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
